import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import {FormattedMessage} from 'react-intl'

const styles = {
  footer: {
    flexGrow: 0,
    height: 30,
    color: '#FFF',
    marginTop: 10,
    textTransform: 'capitalize',
    textShadow: '0 2px 3px black',
  },
}

const Footer = props => {
  const {classes, name} = props
  const date = new Date().getFullYear()
  return (
    <Typography variant="subheading" className={classes.footer} align="center">
      <FormattedMessage
        id="allRightsReserved"
        values={{name: name, date: date}}
      />
    </Typography>
  )
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js